import { render, staticRenderFns } from "./elSettingItem.vue?vue&type=template&id=3740cae0&"
import script from "./elSettingItem.vue?vue&type=script&lang=js&"
export * from "./elSettingItem.vue?vue&type=script&lang=js&"
import style0 from "./elSettingItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports